module.exports = __webpack_public_path__ + "static/media/foto3.a96a0396.jpg";